var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.461,
    viewBox: "0 0 17 17.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-account",
    transform: "translate(-35 -673.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M18.09,11.5v-.957l1.2-1.051A1.251,1.251,0,0,0,19.528,7.9L18.053,5.4a1.261,1.261,0,0,0-1.482-.563l-1.52.513a7.1,7.1,0,0,0-.819-.469L13.912,3.3a1.251,1.251,0,0,0-1.251-1.007H9.735A1.251,1.251,0,0,0,8.484,3.3L8.165,4.877a7.179,7.179,0,0,0-.825.469L5.852,4.808a1.251,1.251,0,0,0-.4-.037A1.251,1.251,0,0,0,4.37,5.4L2.894,7.9a1.251,1.251,0,0,0,.256,1.57L4.332,10.55v.957L3.151,12.557a1.251,1.251,0,0,0-.256,1.595l1.476,2.5a1.261,1.261,0,0,0,1.482.563l1.52-.513a7.1,7.1,0,0,0,.819.469l.319,1.576a1.251,1.251,0,0,0,1.251,1.007h2.952a1.251,1.251,0,0,0,1.251-1.007l.319-1.576a7.18,7.18,0,0,0,.825-.469l1.514.513a1.261,1.261,0,0,0,1.482-.563l1.426-2.5a1.251,1.251,0,0,0-.256-1.57Zm-1.12,4.528L14.826,15.3a5.54,5.54,0,0,1-1.695.982l-.444,2.245H9.736l-.444-2.22A5.853,5.853,0,0,1,7.6,15.327l-2.151.7-1.476-2.5,1.7-1.5a5.566,5.566,0,0,1,0-1.957l-1.7-1.545,1.476-2.5L7.6,6.747a5.54,5.54,0,0,1,1.695-.982l.444-2.245h2.952l.444,2.22a5.853,5.853,0,0,1,1.689.982l2.151-.7,1.476,2.5-1.7,1.5a5.566,5.566,0,0,1,0,1.957l1.7,1.545Z",
    transform: "translate(32.285 671.475)",
    fill: "#45338c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M15,18.754a3.715,3.715,0,1,1,2.664-1.088A3.752,3.752,0,0,1,15,18.754ZM15,12.5a2.445,2.445,0,1,0,1.786.716A2.445,2.445,0,0,0,15,12.5Z",
    transform: "translate(28.495 667.498)",
    fill: "#45338c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.135fc31029dcc5f4bc0d41db2cb3fccc.svg";
export { ForwardRef as ReactComponent };